module.exports = __webpack_public_path__ + "img/address.b97a7d1b.svg";